import PropTypes from 'prop-types';

import { ENV_VARS } from 'ENV_CONFIG';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      Please aim to arrive
      <strong> 5 minutes before </strong>
      your appointment time
    </li>
    <li>
      Now you&apos;ve booked your appointment, your Personal Stylist will call you to find out a
      little bit more about you - that way he or she can be sure to have picked out some outfits or
      garments to try as soon as you arrive
    </li>
    <li>
      It&apos;s really helpful if you can bring along any accessories you might want to match up,
      and to wear or bring underwear that will be suitable for the clothes you&apos;re likely to try
      on
    </li>
    <li>
      During your time with your stylist, you can opt to accompany them to find you more pieces to
      try, or to stay in the Style Studio and relax while they do it for you. Every appointment is
      different - just choose whatever suits you best
    </li>
    <li>
      We hope you&apos;ll love what your stylist suggests for you, but there&apos;s no minimum spend
      expected, or obligation to buy
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};

export const RemoteAppointmentInformation = ({ listItem, gender = null }) => (
  <ul>
    <li>
      Now you&apos;ve booked your appointment, your Personal Stylist will email you to introduce
      themselves and find out a little bit more about what you&apos;re looking for - that way he or
      she can be sure to have prepared before your video call. We will send you further details on
      how to join ahead of your appointment
    </li>
    <li>
      We hope you&apos;ll love what your stylist suggests for you, but there&apos;s no minimum spend
      expected, or obligation to buy
    </li>
    <li>
      At present we will not be able to process your order for you, but you will be able to make
      purchases from&nbsp;
      <a href={`${ENV_VARS.REACT_APP_BROWSE_HOST}`} target="_blank" rel="noopener noreferrer">
        johnlewis.com
      </a>
    </li>
    <li>
      To find out more about the Personal Styling service please&nbsp;
      <a
        href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/our-services/${
          gender === 'MALE' ? 'personal-styling-men' : 'personal-styling'
        }`}
        target="_blank"
        rel="noopener noreferrer"
      >
        visit our website
      </a>
    </li>
    {listItem}
  </ul>
);

RemoteAppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
  gender: PropTypes.string,
};
